import Dropzone from './Dropzone.component';

export default Dropzone;